// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createMassChannelCustomerFollowUp} from '../../shared/repositories';

export const createMassChannelCustomerFollowUpReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const massChannelCustomerFollowupState = getState().reports.massChannelCustomerFollowUp;

        const reportCriteria = {
            dealers: massChannelCustomerFollowupState.selectedDealers
        };

        try {

            const data = await createMassChannelCustomerFollowUp(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_MASS_CHANNEL_CUSTOMER_FOLLOW_UP_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/action-creators/create-report.js